import appStorage from "@/lib/appStorage";
import { isAndroidWebView, isIOSWebView } from "@/lib/browserUtils";
import { PurchaseResponse } from "@/payments/types";

export const createRejectError = (e: unknown): PurchaseResponse => ({
  status: false,
  subjectPurchased: false,
  error: e as Error,
});

type RequestState = "success" | "canceled" | "error";

export const TIMEOUT_TO_CLOSE = 0;

export enum PAYMENT_ERROR_MESSAGES {
  OTHER_PAYMENT = "Other payment in process",
  CREATE_WINDOW = "Can't create payment window",
  CANCELED = "Payment canceled",
  VERIFY_TRANSACTION = "Can't verify transaction",
}

const open = (w: number, h: number) => {
  const left = screen.width / 2 - w / 2,
    top = screen.height / 2 - h / 2;
  const config = `width=${w}, height=${h}, top=${top}, left=${left}, toolbar=0, location=1, directories=0, status=0, menubar=0, scrollbars=1, resizable=0, copyhistory=0,`;
  return window.open("about:blank", "_blank", config);
};

const waitRequestStatus = (getUrl: () => Promise<string>) =>
  new Promise<RequestState>(async (resolve, reject) => {
    if ((window as any).setPaymentRequestStatus) {
      reject(new Error(PAYMENT_ERROR_MESSAGES.OTHER_PAYMENT));
      return;
    }
    let requestStatus: "success" | "canceled";
    (window as any).setPaymentRequestStatus = (status: "success" | "canceled") => {
      requestStatus = status;
    };
    const tab = open(980, 900);
    if (!tab) {
      delete (window as any).setPaymentRequestStatus;
      reject(new Error(PAYMENT_ERROR_MESSAGES.CREATE_WINDOW));
      return;
    }
    tab.location.href = await getUrl();
    const interval = setInterval(() => {
      if (tab.closed) {
        if (requestStatus === "success") {
          resolve("success");
        } else if (requestStatus === "canceled") {
          resolve("canceled");
        } else {
          resolve("error");
        }
        delete (window as any).setPaymentRequestStatus;
        clearInterval(interval);
      }
    }, 500);
  });

export const makePurchase = async (getUrl: () => Promise<string>) => {
  if (isIOSWebView() || isAndroidWebView()) {
    appStorage.setString("payment_success_url", window.location.href);
    window.location.assign(await getUrl());
  }
  const requestState = await waitRequestStatus(getUrl);
  if (requestState === "canceled") {
    throw new Error(PAYMENT_ERROR_MESSAGES.CANCELED);
  } else if (requestState === "error") {
    throw new Error(PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION);
  }
  return true;
};

export const getUrls = (url: string) => {
  const successUrl = new URL(url, location.origin);
  const cancelUrl = new URL(url, location.origin);
  successUrl.searchParams.set("result", "success");
  cancelUrl.searchParams.set("result", "canceled");

  return {
    successUrl: successUrl.toString(),
    cancelUrl: cancelUrl.toString(),
  };
};
